import {Component, Vue} from "vue-property-decorator"
import {i18n, songs} from "@/main"
import Song from "@/song"
import ToolbarSearchWidget from "@/components/ToolbarSearchWidget.vue"

//noinspection JSUnusedGlobalSymbols - Required by Vue to be "export default"
@Component({
  components: {ToolbarSearchWidget}
})
export default class SongListView extends Vue {
  // noinspection JSUnusedLocalSymbols, JSMismatchedCollectionQueryUpdate - used in Vue template
  private songs: Song[] = songs

  private static get title(): HTMLElement {
    return document.querySelector(".md-title") as HTMLElement
  }

  // noinspection JSMethodCanBeStatic, JSUnusedGlobalSymbols - Lifecycle callback from Vue
  public mounted() {
    document.title = i18n.t("app_name").toString()
  }

  // noinspection JSMethodCanBeStatic, JSUnusedLocalSymbols - used in Vue template
  private onStartSearch(): void {
    SongListView.title.style.display = "none"
  }

  // noinspection JSMethodCanBeStatic, JSUnusedLocalSymbols - used in Vue template
  private onEndSearch(): void {
    SongListView.title.style.display = "flex"
  }

  // noinspection JSMethodCanBeStatic, JSUnusedLocalSymbols - used in Vue template
  private onQueryUpdated(query: string): void {
    if (!query) {
      this.songs = songs
      return
    }

    query = query.toLocaleLowerCase()
    this.songs = songs.filter(song =>
        song.lyrics.toLocaleLowerCase().includes(query)
        || song.name.toLocaleLowerCase().includes(query)
    )
  }
}
